<template>
    <RPBaseCard
        :status="status"
        :title="title"
        :subtitle="subtitle"
        class="SingleFieldCard"
    >
        <template slot="leadingIcon">
            <slot name="leadingIcon"></slot>
        </template>
        <template slot="title">
            <slot name="title"></slot>
        </template>
        <template slot="subtitle">
            <slot name="subtitle"></slot>
        </template>

        <div class="SingleFieldCard__actions">
            <slot>
                <RPButton
                    :type="buttonType"
                    :status="status"
                    :label="buttonText"
                    :disabled="disabled"
                    :icon="buttonIcon"
                    size="sm"
                    @click="e => $emit('click', e)"
                />
            </slot>
        </div>
    </RPBaseCard>
</template>
<script>
import RPBaseCard from './RPBaseCard.vue';
import RPButton from 'components/Basic/Buttons/RPButton.vue';
import stat from 'status/index';

export default {
    name: 'RPSingleFieldCard',
    components: {
        RPBaseCard,
        RPButton,
    },
    props: {
        title: {
            type: String,
            default: '',
        },
        subtitle: {
            type: String,
            default: '',
        },
        status: {
            type: String,
            default: stat.STANDBY,
        },
        disabled: {
            type: Boolean,
            default: false
        },
        buttonText: {
            type: String,
            default: ''
        },
        buttonType: {
            type: String,
            default: 'tertiary'
        },
        buttonIcon: {
            type: [Array, Object],
            default: () => ({})
        },
    },
};
</script>
<style lang="scss">
    .SingleFieldCard {
        display: inline-flex;
        justify-content: space-between;
        &__title-container {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
        }
        &__title {
            font-weight: 600;
        }
        &__subtitle{
            color: $grey
        }
        &__actions {
            max-width: 15rem;
            height: fit-content;
            margin: auto 0;
        }
    }
</style>

<docs>
```[import](./RPSingleFieldCardExample.vue)
```
</docs>
